// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

// 登录
import login from '@/views/login';
// 选择店铺
import chooseStore from '@/views/chooseStore/index';
// 新建店铺
import addStore from '@/views/addStore/index';
import index from '@/views/index';
// 修改密码
import updatePwd from '@/views/updatePwd/index';
// 个人中心
import userCenter from '@/views/userCenter/index';
// 用于刷新当前页面
import reflushPage from '@/views/reflushPage/index';
//关于我们
import about from '@/views/about/index';
import authWelcome from '@/views/authWelcome/index';
//alibaba
import alibabaAuth from "../views/alibabaAuth/index.vue";
import sourceMarket from "../views/supplier/sourceMarket.vue";
import toLog from '@/views/toLog/index';
//跳转
import skip from '@/views/skip/index';
//下载pda
import downloadPda from '@/views/downloadPda/index';

import s from '@/views/skip/index2';
import t from '@/views/skip/index3';
// 吉客云配置
// import configuration from '@/views/application/configuration/configuration'
// 启用路由
Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 静态路由
export let constantRoutes = [
  {
    path: '/',
    name: '',
    component: login,
    redirect: '/login',
    hidden: true,
    meta: {
      requireAuth: false,
      keepalive: 0,
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false,
      keepalive: 0,
    }
  }, {
    path: '/about',
    name: '关于我们',
    component: about,
    hidden: true,
    meta: {
      requireAuth: false,
      keepalive: 0,
    }
  }, {
    path: '/chooseStore',
    name: '选择店铺',
    component: chooseStore,
    hidden: true,
    meta: {
      requireAuth: false,
      keepalive: 0,
    }
  }, {
    path: '/addStore',
    name: '新建店铺',
    component: addStore,
    hidden: true,
    meta: {
      requireAuth: false,
      keepalive: 0,
    }
  }, {
    path: '/updatePwd',
    name: '修改密码',
    component: updatePwd,
    hidden: true,
    meta: {
      requireAuth: true,
      keepalive: 0,
    }
  }, {
    path: '/toLog',
    name: '一键登录',
    component: toLog,
    hidden: true,
    meta: {
      requireAuth: false,
      keepalive: 0,
    }
  }, {
    path: '/userCenter',
    name: '个人中心',
    component: userCenter,
    hidden: true,
    meta: {
      requireAuth: true,
      keepalive: 0,
    }
  }, {
    path: '/authWelcome',
    name: '注册成功',
    component: authWelcome,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/alibabaAuth',
    name: '阿里巴巴',
    component: alibabaAuth,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/skip/:shop_id/:other_id/:sn',
    name: '跳转',
    component: skip,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/s/:shop_id/:other_id/:sn',
    name: '跳转',
    component: s,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/t/:shop_id/:sn',
    name: '跳转',
    component: t,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/downloadPda',
    name: '跳转',
    component: downloadPda,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  //   {
  //   path: '/createCashierDesk',
  //   name: '收银台',
  //   component:createCashierDesk,
  //   meta: {
  //     requireAuth: true,
  //   }
  // },
  // {
  //   path: '/configuration',
  //   name: '吉客云配置',
  //   component: configuration,
  //   hidden: true,
  //   meta: {
  //     requireAuth: false
  //   }
  // }
  // ,
  {
    path: '/index',
    component: index,
    name: 'index',
    iconCls: 'el-icon-tickets',
    children: [
      {
        path: '/reflushPage',
        name: '用于刷新当前页面',
        component: reflushPage,
        meta: {
          requireAuth: true,
          keepalive: 0,
        }
      },
      {
        path: '/sourceMarket',
        name: '货源市场',
        component: sourceMarket,
        meta: {
          requireAuth: true,
        }
      },
    ]
  }
]

//动态路由
export const asyncRoutes = []

const createRouter = () => new Router({ routes: constantRoutes })
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js